/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Seo from "./seo";
import { Flex, NavLink } from 'theme-ui';
import { Link } from 'gatsby';
import { SocialIcon } from 'react-social-icons';

const Layout = ({ seoParams, children }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          social {
            name
            url
          }
          menuLinks {
            name
            link
          }
        }
      }
    }
  `
  );

  return (
    <React.Fragment>
      <Seo title={seoParams?.title || site.siteMetadata.title} />
      <header sx={{ borderBottom: "1px solid #e8e8e8"}}>
        <Flex as="nav"
          sx={{ 
            justifyContent: "flex-end",
            alignItems: "center",
            maxWidth: "800px",
            px: 30,
            margin: "auto"
          }}
        >
          {site.siteMetadata.menuLinks.map((link, idx) => (
            idx === 0 ?
            <NavLink key={0} p={2} to={link.link} key={link.name} as={Link} sx={{ marginRight: "auto", fontSize: 24 }}>{link.name}</NavLink> :
            <NavLink key={idx} p={2} to={link.link} key={link.name} as={Link}>{link.name}</NavLink>
          ))}
        </Flex>
      </header>

      <Flex as="main"
        sx={{
          p: "30px 0",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div sx={{
          maxWidth: "800px",
          px: 30,
          margin: "auto"
        }}>
          {children}
        </div>
      </Flex>

      <Flex as="footer"
        sx={{
          borderTop: "1px solid #e8e8e8",
          padding: "30px 0px"
        }}
      >
        <div
          sx={{ 
            maxWidth: "800px",
            px: 30,
            marginLeft: "auto",
            marginRight: "auto",
            flexDirection: "column"
          }}
        >
          <Flex>
            <h2 sx={{
                fontSize: 18,
                margin: 0,
                padding: 0,
                fontWeight: 400,
              }}
            >
              {site.siteMetadata.title}
            </h2>
            <p sx={{ margin: 0 }}>
              {site.siteMetadata.description}
            </p>
            <div>
              <h3 sx={{
                fontSize: 18,
                margin: 0,
                padding: 0,
                fontWeight: 400,
              }}>
                Connect with me!
              </h3>
              {site.siteMetadata.social.map(icon => <SocialIcon key={icon.url} url={icon.url} style={{ height: 25, width: 25, marginRight: 12 }} label={icon.name}/>)}
            </div>
          </Flex>
        </div>

      </Flex>
    </React.Fragment>
  )
}

export default Layout;
